import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import promiseMiddleware from "redux-promise-middleware";
//
import socket from "./services/socket";
import Storage from "./services/Storage";
import rootReducer from "./reducers";
import { showModal, showCarousal } from "./modules/modal";
import { setModelAction } from "./modules/models/actions";
import searchAction from "./modules/models/searchAction";
import { setDurationAction } from "./modules/booking/actions";
import { getUserAction } from "./modules/auth";
import BackButton from "./services/BackButton";
import Copier from "./services/Copier";
import { setAccessToken, setSocketId } from "./services/http/tokens";
import { setRefreshToken } from "./services/http/refresh-token";

const { debug } = window.SERVER;

// Middlewares
let middles = applyMiddleware(promiseMiddleware(), thunk);
if (debug && window.__REDUX_DEVTOOLS_EXTENSION__) {
  middles = compose(
    middles,
    window.__REDUX_DEVTOOLS_EXTENSION__()
  );
}

// Create store
export default function configureStore(preloadedState = {}) {
  const store = createStore(rootReducer, preloadedState, middles);

  // Public API
  window.Copier = Copier;
  window.openApp = () => {
    store.dispatch(showModal());
  };
  window.openCarousal = (modelId, idx) => {
    store.dispatch(showModal());
    store.dispatch(setModelAction(modelId));
    store.dispatch(showCarousal(idx));
  };
  window.setBookingDuration = (duration) => {
    store.dispatch(setDurationAction(duration));
    store.dispatch(showModal());
  };
  window.searchAction = () => {
    document.body.classList.add("modal-loading");
    store.dispatch(searchAction());
  };

  // Services
  BackButton.init(store);

  return rehydrate(store).then(() => store);
}

async function rehydrate(store) {
  const tokens = await Storage.get("tokens");
  const works = [];

  if (tokens) {
    setAccessToken(tokens.access_token);
    setRefreshToken(tokens.refresh_token);

    socket.setAccessToken(tokens.access_token);
    socket.getSocketId().then((id) => setSocketId(id));

    works.push(store.dispatch(getUserAction()));
  }

  return Promise.all(works);
}
